import { Button, Col, Input, Pagination, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { PeriodsCombo } from '../Components/Period/PeriodsCombo';
import { SubPeriodCombo } from '../Components/SubPeriod/SubPeriodCombo';
import { ObjectInstanceCombo } from '../Components/ObjectInstance/ObjectInstanceCombo';
import { ReserveStatusCombo } from '../Components/Reserve/ReserveStatusCombo';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
import { ClearOutlined, PrinterOutlined, SearchOutlined } from '@ant-design/icons';
import { AdvanceSearch_Paging_Reserve_Api } from '../API/ReserveApi';
import { ReservesGrid } from '../Components/Reserve/ReservesGrid';
import { AReserveComponent } from '../Components/Reserve/AReserveComponent';
import { AReserveFoodsAndParking } from '../Components/FoodAndParkingReserve/AReserveFoodsAndParking';
import { PrintReservesTable } from '../Components/Reserves/PrintReservesTable';
// -----------------------------------------------------------
// وارد کردن DatePicker و تنظیمات شمسی
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------
import { useRef } from 'react';


// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD";

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim();

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-");
};

// =================================================================
/**
 * آداپتور سفارشی PersianDatePickerAdapter برای استفاده در فرم جستجو
 */
const PersianDatePickerAdapter = ({ value, onChange, placeholder }) => {
    const handleOnChange = (dateObject) => {
        let dateString = null;
        if (dateObject && !Array.isArray(dateObject)) {
            dateString = persianToEnglishNumbers(dateObject.format(SERVER_DATE_FORMAT));
        }
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input"
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT}
            placeholder={placeholder}
            style={{ width: '100%' }}
        />
    );
};
// =================================================================

export const AdvanceSearch = ({ setLoading, showMessage, userRole = "" }) => {
    // =================================================================
    const [view, setView] = useState('ShowSearch');
    const [selectedId, setSelectedId] = useState(0);
    const [version, setVersion] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(4);
    const [rowCount, setRowCount] = useState();
    const [reserves, setReserves] = useState([]);

    const [trackingCode, setTrackingCode] = useState('');
    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState();
    const [mobile, setMobile] = useState();
    const [periodId, setPeriodId] = useState(null);
    const [subPeriodId, setSubPeriodId] = useState(null);
    const [objectInstanceId, setObjectInstanceId] = useState(null);
    const [reserveStatus, setReserveStatus] = useState(null);
    // =================================================================
    const [fromStartDate, setFromStartDate] = useState(null);
    const [fromEndDate, setFromEndDate] = useState(null);

    const [toStartDate, setToStartDate] = useState(null);
    const [toEndDate, setToEndDate] = useState(null);

    const [registerStartDate, setRegisterStartDate] = useState(null);
    const [registerEndDate, setRegisterEndDate] = useState(null);

    const [pageSize, setPageSize] = useState(15);
    const [sortColumn, setSortColumn] = useState('createDate');
    const [sortOrder, setSortOrder] = useState('descend');
    const [totalItems, setTotalItems] = useState(0);

    // ref برای چاپ
    const printRef = useRef();
    // =================================================================

    // تابع برای ایجاد searchCriteria از stateهای فعلی
    const getSearchCriteria = () => {
        return {
            trackingCode,
            fullName,
            nationalCode,
            mobile,
            periodId: periodId ? periodId.toString() : '',
            subPeriodId: subPeriodId ? subPeriodId.toString() : '',
            objectInstanceId: objectInstanceId ? objectInstanceId.toString() : '',
            reserveStatus: reserveStatus ? reserveStatus.toString() : '',
            fromStartDate: fromStartDate || '',
            fromEndDate: fromEndDate || '',
            toStartDate: toStartDate || '',
            toEndDate: toEndDate || '',
            registerStartDate: registerStartDate || '',
            registerEndDate: registerEndDate || '',
        };
    };

    // =================================================================
    useEffect(() => {
        submitSearch();
    }, [currentPage, pageSize, sortColumn, sortOrder, version]);

    // =================================================================
    const submitSearch = async (page = currentPage, size = pageSize, column = sortColumn, order = sortOrder) => {
        try {
            const params = {
                trackingCode: trackingCode ? trackingCode : 0,
                fullName: fullName ?? '',
                nationalCode: nationalCode ?? '',
                mobile: mobile ?? '',
                periodId: periodId ?? 0,
                subPeriodId: subPeriodId ?? 0,
                objectInstanceId: objectInstanceId ?? 0,
                reserveStatus: reserveStatus ?? 0,
                fromStartDate: fromStartDate ?? '',
                fromEndDate: fromEndDate ?? '',
                toStartDate: toStartDate ?? '',
                toEndDate: toEndDate ?? '',
                registerStartDate: registerStartDate ?? '',
                registerEndDate: registerEndDate ?? '',
                pageNumber: currentPage ?? 1,
                pageSize: size,
                sortColumn: column,
                sortOrder: order === 'ascend' ? 'asc' : (order === 'descend' ? 'desc' : undefined),
            }
            setLoading(true);
            params.pageNumber = page;

            let data = await AdvanceSearch_Paging_Reserve_Api(params);

            if (data.messageStatus === "Successful") {
                setReserves(data.messageData.data);
                setTotalItems(data.messageData.additional || 0);
                setRowCount(data.messageData.additional || 0);
            }
            else {
                showMessage(data.message, "error");
            }
        }
        catch (error) {
            showMessage("خطا در ارتباط با سرور", "error");
        }
        finally {
            setLoading(false);
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.columnKey !== sortColumn || sorter.order !== sortOrder) {
            setSortColumn(sorter.columnKey);
            setSortOrder(sorter.order);
            setCurrentPage(1);
        }
    };

    const handlePageChange = (page, currentSize) => {
        setCurrentPage(Number(page));
        if (currentSize && Number(currentSize) !== pageSize) {
            setPageSize(Number(currentSize));
        }
    };

    const resetSearchForm = () => {
        setTrackingCode('');
        setFullName('');
        setNationalCode('');
        setMobile('');
        setPeriodId(null);
        setSubPeriodId(null);
        setObjectInstanceId(null);
        setReserveStatus(null);
        setFromStartDate(null);
        setFromEndDate(null);
        setToStartDate(null);
        setToEndDate(null);
        setRegisterStartDate(null);
        setRegisterEndDate(null);
        setCurrentPage(1);
    };

 // تابع چاپ ساده - مثل روش قبلی شما
    const handlePrintTable = () => {
        if (!reserves || reserves.length === 0) {
            showMessage('هیچ داده‌ای برای چاپ وجود ندارد', 'warning');
            return;
        }
        
        // نمایش بخش چاپ
        setTimeout(() => {
            window.print();
        }, 100);
    };

// const handlePrintTable = () => {
//     const originalContents = document.body.innerHTML;
//     const printContents = document.querySelector('.reserve-info-container').outerHTML;
    
//     document.body.innerHTML = `
//         <html>
//             <head>
//                 <title>گزارش رزروها</title>
//                 <style>
//                     @page { size: A4; margin: 15mm; }
//                     body { margin: 0; padding: 0; }
//                     table { width: 100%; border-collapse: collapse; }
//                     th, td { border: 1px solid #000; padding: 5px; }
//                 </style>
//             </head>
//             <body>${printContents}</body>
//         </html>
//     `;
    
//     window.print();
//     document.body.innerHTML = originalContents;
//     window.location.reload();
// };
    // =================================================================
    
    return (
        
        <>
        
            {view === "ShowSearch" ?
                <>
                <div className="no-print">
                    <Row className='sectionTitle'>
                        <Col span={24}>
                            <h2>جستجوی پیشرفته</h2>
                        </Col>
                    </Row>
                    <div className='container'>
    <Row gutter={[16, 16]} align="middle">
        {/* ردیف اول: شماره پیگیری - نام و نام خانوادگی */}
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Row gutter={[16, 16]} align="middle">
                <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                    شماره پیگیری:
                </Col>
                <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                    <Input placeholder='شماره پیگیری' value={trackingCode} onChange={(e) => { setTrackingCode(e.target.value) }} />
                </Col>
            </Row>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Row gutter={[16, 16]} align="middle">
                <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                    نام و نام خانوادگی:
                </Col>
                <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                    <Input placeholder='قسمتی از نام' value={fullName} onChange={(e) => { setFullName(e.target.value) }} />
                </Col>
            </Row>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Row gutter={[16, 16]} align="middle">
                <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                    کد ملی:
                </Col>
                <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                    <Input placeholder='کد ملی' value={nationalCode} onChange={(e) => { setNationalCode(e.target.value) }} />
                </Col>
            </Row>
        </Col>

        {/* فیلدهای زیر فقط برای کاربران با role غیر از 2 نمایش داده می‌شوند */}
        {(userRole == 'SuperAdmin' || userRole == 'Admin') && (
            <>
                {/* ردیف دوم: تلفن همراه - دوره ثبت نام - زیردوره */}
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                            تلفن همراه:
                        </Col>
                        <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                            <Input placeholder='تلفن همراه' value={mobile} onChange={(e) => { setMobile(e.target.value); }} />
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                            دوره ثبت نام:
                        </Col>
                        <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                            <PeriodsCombo
                                setLoading={setLoading}
                                showMessage={showMessage}
                                allowClear 
                                value={periodId}
                                onChange={(value) => { setPeriodId(value); }} />
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                            زیردوره:
                        </Col>
                        <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                            <SubPeriodCombo
                                setLoading={setLoading}
                                showMessage={showMessage}
                                periodId={periodId}
                                value={subPeriodId}
                                onChange={(value) => { setSubPeriodId(value); }} />
                        </Col>
                    </Row>
                </Col>
                </>
                )}

                {/* ردیف سوم: اتاق - وضعیت ثبت نام - (فضای خالی یا فیلد سوم اگر وجود دارد) */}
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                            اتاق:
                        </Col>
                        <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                            <ObjectInstanceCombo
                                setLoading={setLoading}
                                showMessage={showMessage}
                                allowClear 
                                value={objectInstanceId}
                                onChange={(value) => { setObjectInstanceId(value); }} />
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={12} sm={8} md={8} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                            وضعیت ثبت نام:
                        </Col>
                        <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                            <ReserveStatusCombo
                                setLoading={setLoading}
                                showMessage={showMessage}
                                allowClear 
                                value={reserveStatus}
                                onChange={(value) => { setReserveStatus(value); }} />
                        </Col>
                    </Row>
                </Col>
                <>
                 {/* می‌توانید در اینجا یک فیلد سوم یا یک Col خالی برای حفظ چینش سه ستونی اضافه کنید */}
                 <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    {/* فیلد سوم یا فضای خالی */}
                 </Col>

                {/* بخش تاریخ‌ها - هر کدام در یک Col جداگانه با عرض 8 در lg و xl */}
                <Col xs={24} sm={24} md={12} lg={8} xl={8} style={{ marginBottom: '16px' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>شروع اقامت:</div>
                    <Row gutter={8}>
                        <Col span={12}>
                            <PersianDatePickerAdapter
                                onChange={setFromStartDate}
                                value={fromStartDate}
                                placeholder={"از تاریخ"}
                            />
                        </Col>
                        <Col span={12}>
                            <PersianDatePickerAdapter
                                onChange={setFromEndDate}
                                value={fromEndDate}
                                placeholder={"تا تاریخ"}
                            />
                        </Col>
                    </Row>
                </Col>

                <Col xs={24} sm={24} md={12} lg={8} xl={8} style={{ marginBottom: '16px' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>پایان اقامت:</div>
                    <Row gutter={8}>
                        <Col span={12}>
                            <PersianDatePickerAdapter
                                onChange={setToStartDate}
                                value={toStartDate}
                                placeholder={"از تاریخ"}
                            />
                        </Col>
                        <Col span={12}>
                            <PersianDatePickerAdapter
                                onChange={setToEndDate}
                                value={toEndDate}
                                placeholder={"تا تاریخ"}
                            />
                        </Col>
                    </Row>
                </Col>

                <Col xs={24} sm={24} md={12} lg={8} xl={8} style={{ marginBottom: '16px' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>تاریخ ثبت نام:</div>
                    <Row gutter={8}>
                        <Col span={12}>
                            <PersianDatePickerAdapter
                                onChange={setRegisterStartDate}
                                value={registerStartDate}
                                placeholder={"از تاریخ"}
                            />
                        </Col>
                        <Col span={12}>
                            <PersianDatePickerAdapter
                                onChange={setRegisterEndDate}
                                value={registerEndDate}
                                placeholder={"تا تاریخ"}
                            />
                        </Col>
                    </Row>
                </Col>
            </>
        
    </Row>
</div>



   {/* بخش دکمه‌ها */}
<Row style={{ padding: '10px' }} gutter={[16, 16]} justify="start" align="middle">
                        <Col xs={24} sm={8} md={6} lg={4} xl={3}>
                            <Button
                                className='btn-success'
                                onClick={() => { setCurrentPage(1); setVersion(v => v + 1); }}
                                style={{ width: '100%' }}
                                icon={<SearchOutlined />}
                            >
                                جستجو
                            </Button>
                        </Col>

                        <Col xs={24} sm={8} md={6} lg={4} xl={3}>
                            <Button
                                className='btn-warning'
                                onClick={resetSearchForm}
                                style={{ width: '100%' }}
                                icon={<ClearOutlined />}
                            >
                                حذف شرایط
                            </Button>
                        </Col>

                        <Col xs={24} sm={8} md={6} lg={4} xl={3}>
                            <Button
                                className='btn-info no-print'
                                onClick={handlePrintTable}
                                style={{ width: '100%' }}
                                icon={<PrinterOutlined />}
                                disabled={!reserves || reserves.length === 0}
                            >
                                چاپ جدول ({reserves.length})
                            </Button>
                        </Col>

                        <Col xs={24} sm={24} md={12} lg={12} xl={15}>
                            {rowCount !== undefined ?
                                <>
                                    {rowCount > 0 ?
                                        <div style={{ padding: '8px 0', textAlign: 'center' }}>
                                            <span>تعداد </span><b>{rowCount}</b><span> رکورد یافت شد</span>
                                        </div>
                                        : <div style={{ padding: '8px 0', textAlign: 'center' }}><span>رکوردی یافت نشد.</span></div>}
                                </>
                                : <></>
                            }
                        </Col>
                    </Row>



                    <ReservesGrid
                        reserves={reserves}
                        onItemClick={(id) => { setSelectedId(id); setView('AReserve') }}
                        currentSortColumn={sortColumn}
                        currentSortOrder={sortOrder}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        onTableChange={handleTableChange}
                    />

                    {totalItems > 0 ?
                        <ConfigProvider direction="rtl" locale={faIR}>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                showSizeChanger={true}
                                pageSizeOptions={['15', '30', '50', '75']}
                                showQuickJumper={false}
                                align="center"
                                onChange={handlePageChange}
                                onShowSizeChange={handlePageChange}
                                total={totalItems}
                            />
                        </ConfigProvider>
                        
                        : <></>}
                        </div>
{/* بخش چاپ - فقط هنگام چاپ نمایش داده می‌شود */}
                    <div className="only-print">
                        <PrintReservesTable 
                            reserves={reserves}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            searchCriteria={getSearchCriteria()}
                        />
                    </div>
                </> 
                
                : <></>}

            {view === "AReserve" ?
                <AReserveComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedId}
                    onBackClick={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
                    onFoodClick={(id) => { setSelectedId(id); setView('AFoodReserve'); }}
                /> : <></>}

            {view === "AFoodReserve" ?
                <AReserveFoodsAndParking
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedId}
                    onBackClick={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
                    onPayCompleted={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
                /> : <></>}
        </>
    );
};







// import { Button, Col, Input, Pagination, Row } from 'antd';
// import React, { useEffect, useState } from 'react';
// import { PeriodsCombo } from '../Components/Period/PeriodsCombo';
// import { SubPeriodCombo } from '../Components/SubPeriod/SubPeriodCombo';
// import { ObjectInstanceCombo } from '../Components/ObjectInstance/ObjectInstanceCombo';
// import { ReserveStatusCombo } from '../Components/Reserve/ReserveStatusCombo';
// import { ConfigProvider } from 'antd';
// import faIR from 'antd/locale/fa_IR';
// import { ClearOutlined, PrinterOutlined, SearchOutlined } from '@ant-design/icons';
// import { AdvanceSearch_Paging_Reserve_Api } from '../API/ReserveApi';
// import { ReservesGrid } from '../Components/Reserve/ReservesGrid';
// import { AReserveComponent } from '../Components/Reserve/AReserveComponent';
// import { AReserveFoodsAndParking } from '../Components/FoodAndParkingReserve/AReserveFoodsAndParking';

// // -----------------------------------------------------------
// // وارد کردن DatePicker و تنظیمات شمسی
// import DatePicker, { DateObject } from "react-multi-date-picker";
// import persian from "react-date-object/calendars/persian";
// import persian_fa from "react-date-object/locales/persian_fa";
// // -----------------------------------------------------------
// import { useReactToPrint } from 'react-to-print';
// import { useRef } from 'react';
// import { PrintableReservesReport } from './PrintableReservesReport'; // مسیر کامپوننت چاپ شما

// // =================================================================
// const SERVER_DATE_FORMAT = "YYYY-MM-DD";

// /**
//  * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
//  */
// const persianToEnglishNumbers = (str) => {
//     if (!str) return '';
//     let output = String(str).trim();

//     const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
//     const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
//     const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

//     for (let i = 0; i < 10; i++) {
//         output = output.replace(persianNumbers[i], englishNumbers[i]);
//         output = output.replace(arabicNumbers[i], englishNumbers[i]);
//     }

//     return output.replace(/\//g, "-");
// };

// // =================================================================
// /**
//  * آداپتور سفارشی PersianDatePickerAdapter برای استفاده در فرم جستجو
//  */
// const PersianDatePickerAdapter = ({ value, onChange, placeholder }) => {
//     const handleOnChange = (dateObject) => {
//         let dateString = null;
//         if (dateObject && !Array.isArray(dateObject)) {
//             dateString = persianToEnglishNumbers(dateObject.format(SERVER_DATE_FORMAT));
//         }
//         onChange(dateString);
//     };

//     return (
//         <DatePicker
//             calendar={persian}
//             locale={persian_fa}
//             onChange={handleOnChange}
//             inputClass="ant-input persian-date-input"
//             calendarPosition="bottom-right"
//             format={SERVER_DATE_FORMAT}
//             placeholder={placeholder}
//         />
//     );
// };
// // =================================================================


// export const AdvanceSearch = ({ setLoading, showMessage , userRole = ""}) => {
//     // =================================================================
//     const [view, setView] = useState('ShowSearch');
//     const [selectedId, setSelectedId] = useState(0);
//     const [version, setVersion] = useState(0);

//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageCount, setPageCount] = useState(4);
//     const [rowCount, setRowCount] = useState();
//     const [reserves, setReserves] = useState([]);

//     const [trackingCode, setTrackingCode] = useState('');
//     const [fullName, setFullName] = useState("");
//     const [nationalCode, setNationalCode] = useState();
//     const [mobile, setMobile] = useState();
//     const [periodId, setPeriodId] = useState(null);
//     const [subPeriodId, setSubPeriodId] = useState(null);
//     const [objectInstanceId, setObjectInstanceId] = useState(null);
//     const [reserveStatus, setReserveStatus] = useState(null);
//     // =================================================================
//     const [fromStartDate, setFromStartDate] = useState(null);
//     const [fromEndDate, setFromEndDate] = useState(null);

//     const [toStartDate, setToStartDate] = useState(null);
//     const [toEndDate, setToEndDate] = useState(null);

//     const [registerStartDate, setRegisterStartDate] = useState(null);
//     const [registerEndDate, setRegisterEndDate] = useState(null);

//     const [pageSize, setPageSize] = useState(15); // پیش فرض 10
//     // وضعیت های مرتب سازی
//     const [sortColumn, setSortColumn] = useState('createDate'); // ستون پیش فرض مرتب سازی
//     const [sortOrder, setSortOrder] = useState('descend'); // جهت پیش فرض مرتب سازی

//     const [totalItems, setTotalItems] = useState(0); // برای total در Pagination
//     // ---------------------------------------
//     // =================================================================
//     useEffect(() => {
//         // Initial search on component load or state change
//         submitSearch();
//     }, [currentPage, pageSize, sortColumn, sortOrder, version]);

//     // =================================================================
//     const submitSearch = async (page = currentPage, size = pageSize, column = sortColumn, order = sortOrder) => {
//         try {
//             const params = {
//                 trackingCode: trackingCode ? trackingCode : 0,
//   fullName: fullName ?? '',
//   nationalCode: nationalCode ?? '',
//   mobile: mobile ?? '',
//   periodId: periodId ?? 0,
//   subPeriodId: subPeriodId ?? 0,
//   objectInstanceId: objectInstanceId ?? 0,
//   reserveStatus: reserveStatus ?? 0,
//   fromStartDate: fromStartDate ?? '',
//   fromEndDate: fromEndDate ?? '',
//   toStartDate: toStartDate ?? '',
//   toEndDate: toEndDate ?? '',
//   registerStartDate: registerStartDate ?? '',
//   registerEndDate: registerEndDate ?? '',
//   pageNumber: currentPage ?? 1,
//   pageSize: size,               // استفاده از پارامتر size
//                 sortColumn: column,           // استفاده از پارامتر column
//                 sortOrder: order === 'ascend' ? 'asc' : (order === 'descend' ? 'desc' : undefined), // تبدیل برای API
//             }
//             setLoading(true);
//             params.pageNumber = page;
            
//             let data = await AdvanceSearch_Paging_Reserve_Api(params);
            
//             if (data.messageStatus === "Successful") {
//                 setReserves(data.messageData.data);
//                // setPageCount(data.messageData.pageCount * 10);
//                 //setRowCount(data.messageData.additional);
//                 setTotalItems(data.messageData.additional || 0); // فرض می کنیم additional همان totalCount است
//                 // اگر server شما pageCount را برمی گرداند، می توانید آن را در اینجا استفاده کنید،
//                 // اما برای Pagination کامپوننت، totalItems کافی است.
//             }
//             else {
//                 showMessage(data.message, "error");
//             }
//         }
//         catch (error) {
//             showMessage("خطا در ارتباط با سرور", "error");
//         }
//         finally {
//             setLoading(false);
//         }
//     };

//     const handleTableChange = (pagination, filters, sorter) => {
//         // اگر تغییر در مرتب سازی (sorter) وجود دارد
//         if (sorter.columnKey !== sortColumn || sorter.order !== sortOrder) {
//             setSortColumn(sorter.columnKey);
//             setSortOrder(sorter.order);
//             setCurrentPage(1); // با هر مرتب سازی جدید، به صفحه اول برگردیم
//         }
//     };

//        const handlePageChange = (page, currentSize) => {
//     // page و currentSize را به عدد تبدیل کنید تا از رشته بودن جلوگیری شود (اگر از Pagination Ant Design می آیند)
//     setCurrentPage(Number(page));
//     if (currentSize && Number(currentSize) !== pageSize) {
//         setPageSize(Number(currentSize));
//     }
// };

// const resetSearchForm = () => {
//     setTrackingCode('');
//     setFullName('');
//     setNationalCode('');
//     setMobile('');
//     setPeriodId(null);
//     setSubPeriodId(null);
//     setObjectInstanceId(null);
//     setReserveStatus(null);
//     setFromStartDate(null);
//     setFromEndDate(null);
//     setToStartDate(null);
//     setToEndDate(null);
//     setRegisterStartDate(null);
//     setRegisterEndDate(null);
//     setCurrentPage(1);
// };


// const printRef = useRef();
    
//     // پیکربندی تابع چاپ
//     const handlePrint = useReactToPrint({
//         content: () => printRef.current,
//         documentTitle: 'گزارش_رزروها', // عنوان فایل هنگام چاپ
//         onAfterPrint: () => console.log('چاپ با موفقیت انجام شد'),
//     });



//     // =================================================================
// return (
//     <>
//         {view === "ShowSearch" ?
//             <>
//                 <Row className='sectionTitle'>
//                     <Col span={24}>
//                         <h2>جستجوی پیشرفته</h2>
//                     </Col>
//                 </Row>
//                 <div className='container'>
//                     <Row gutter={[16, 16]}>
//                         {/* ردیف اول */}
//                         <Col xs={24} sm={12} md={6} lg={4} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                             شماره پیگیری:
//                         </Col>
//                         <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                             <Input placeholder='شماره پیگیری' value={trackingCode} onChange={(e) => { setTrackingCode(e.target.value) }} />
//                         </Col>

//                         <Col xs={24} sm={12} md={6} lg={4} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                             نام و نام خانوادگی:
//                         </Col>
//                         <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                             <Input placeholder='قسمتی از نام و نام خانوادگی' value={fullName} onChange={(e) => { setFullName(e.target.value) }} />
//                         </Col>

//                         <Col xs={24} sm={12} md={6} lg={3} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }} >
//                             کد ملی:
//                         </Col>
//                         <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                             <Input placeholder='کد ملی' value={nationalCode} onChange={(e) => { setNationalCode(e.target.value) }} />
//                         </Col>

//                         {/* فیلدهای زیر فقط برای کاربران با role غیر از 2 نمایش داده می‌شوند */}
//                         {(userRole == 'SuperAdmin' || userRole == 'Admin') && (
//                             <>
//                                 {/* ردیف دوم */}
//                                 <Col xs={24} sm={12} md={6} lg={4} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                                     تلفن همراه:
//                                 </Col>
//                                 <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                                     <Input placeholder='تلفن همراه' value={mobile} onChange={(e) => { setMobile(e.target.value); }} />
//                                 </Col>

//                                 <Col xs={24} sm={12} md={6} lg={4} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                                     دوره ثبت نام:
//                                 </Col>
//                                 <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                                     <PeriodsCombo
//                                         setLoading={setLoading}
//                                         showMessage={showMessage}
//                                         value={periodId}
//                                         onChange={(value) => { setPeriodId(value); }} />
//                                 </Col>

//                                 <Col xs={24} sm={12} md={6} lg={3} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                                     زیردوره:
//                                 </Col>
//                                 <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                                     <SubPeriodCombo
//                                         setLoading={setLoading}
//                                         showMessage={showMessage}
//                                         periodId={periodId}
//                                         value={subPeriodId}
//                                         onChange={(value) => { setSubPeriodId(value); }} />
//                                 </Col>

//                                 {/* ردیف سوم */}
//                                 <Col xs={24} sm={12} md={6} lg={4} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                                     اتاق:
//                                 </Col>
//                                 <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                                     <ObjectInstanceCombo
//                                         setLoading={setLoading}
//                                         showMessage={showMessage}
//                                         value={objectInstanceId}
//                                         onChange={(value) => { setObjectInstanceId(value); }} />
//                                 </Col>

//                                 <Col xs={24} sm={12} md={6} lg={4} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
//                                     وضعیت ثبت نام:
//                                 </Col>
//                                 <Col xs={24} sm={12} md={6} lg={5} xl={4}>
//                                     <ReserveStatusCombo
//                                         setLoading={setLoading}
//                                         showMessage={showMessage}
//                                         value={reserveStatus}
//                                         onChange={(value) => { setReserveStatus(value); }} />
//                                 </Col>

//                                 <Col span={24} style={{ paddingBottom: '10px', marginBottom: '10px', borderBottom: "1px solid #cdcdcd" }} />

//                                 {/* بخش تاریخ‌ها با responsive بهتر */}
//                                 <Col xs={24} sm={24} md={12} lg={8} xl={6} style={{ marginBottom: '16px' }}>
//                                     <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>شروع اقامت:</div>
//                                     <Row gutter={8}>
//                                         <Col span={12}>
//                                             <PersianDatePickerAdapter 
//                                                 onChange={setFromStartDate} 
//                                                 value={fromStartDate}
//                                                 placeholder={"از تاریخ"} 
//                                                 style={{ width: '100%' }}
//                                             />
//                                         </Col>
//                                         <Col span={12}>
//                                             <PersianDatePickerAdapter 
//                                                 onChange={setFromEndDate} 
//                                                 value={fromEndDate}
//                                                 placeholder={"تا تاریخ"} 
//                                                 style={{ width: '100%' }}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </Col>

//                                 <Col xs={24} sm={24} md={12} lg={8} xl={6} style={{ marginBottom: '16px' }}>
//                                     <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>پایان اقامت:</div>
//                                     <Row gutter={8}>
//                                         <Col span={12}>
//                                             <PersianDatePickerAdapter 
//                                                 onChange={setToStartDate} 
//                                                 value={toStartDate}
//                                                 placeholder={"از تاریخ"} 
//                                                 style={{ width: '100%' }}
//                                             />
//                                         </Col>
//                                         <Col span={12}>
//                                             <PersianDatePickerAdapter 
//                                                 onChange={setToEndDate} 
//                                                 value={toEndDate}
//                                                 placeholder={"تا تاریخ"} 
//                                                 style={{ width: '100%' }}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </Col>

//                                 <Col xs={24} sm={24} md={12} lg={8} xl={6} style={{ marginBottom: '16px' }}>
//                                     <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>تاریخ ثبت نام:</div>
//                                     <Row gutter={8}>
//                                         <Col span={12}>
//                                             <PersianDatePickerAdapter 
//                                                 onChange={setRegisterStartDate} 
//                                                 value={registerStartDate}
//                                                 placeholder={"از تاریخ"} 
//                                                 style={{ width: '100%' }}
//                                             />
//                                         </Col>
//                                         <Col span={12}>
//                                             <PersianDatePickerAdapter 
//                                                 onChange={setRegisterEndDate} 
//                                                 value={registerEndDate}
//                                                 placeholder={"تا تاریخ"} 
//                                                 style={{ width: '100%' }}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </Col>
//                             </>
//                         )}
//                     </Row>
//                 </div>

//                 {/* بخش دکمه‌ها */}
//                 <Row style={{ padding: '10px' }} gutter={[16, 16]}>
//                     <Col xs={24} sm={12} md={8} lg={6} xl={4}>
//                         <Button 
//                             className='btn-success' 
//                             onClick={() => { setCurrentPage(1); setVersion(v => v + 1); }} 
//                             style={{ width: '100%' }}
//                             icon={<SearchOutlined />}
//                         >
//                             جستجو
//                         </Button>
//                     </Col>
                    
//                     <Col xs={24} sm={12} md={8} lg={6} xl={4}>
//                         <Button 
//                             className='btn-warning' 
//                             onClick={resetSearchForm}
//                             style={{ width: '100%' }}
//                             icon={<ClearOutlined />}
//                         >
//                             حذف شرایط
//                         </Button>
//                     </Col>
//                     // در بخش دکمه‌ها، دکمه چاپ رو به این صورت آپدیت کنید
// <Col xs={24} sm={12} md={8} lg={6} xl={4}>
//     <Button 
//         className='btn-info no-print' 
//         onClick={handlePrint}
//         style={{ width: '100%' }}
//         icon={<PrinterOutlined />}
//     >
//         چاپ اطلاعات
//     </Button>
// </Col>

                    
//                     {/* <Col xs={24} sm={12} md={8} lg={6} xl={4}>
//                         <Button 
//                             className='btn-info' 
//                             onClick={() => window.print()}
//                             style={{ width: '100%' }}
//                             icon={<PrinterOutlined />}
//                         >
//                             چاپ اطلاعات
//                         </Button>
//                     </Col> */}
                    
//                     <Col xs={24} sm={12} md={8} lg={6} xl={12}>
//                         {rowCount !== undefined ?
//                             <>
//                                 {rowCount > 0 ?
//                                     <div style={{ padding: '8px 0', textAlign: 'center' }}>
//                                         <span>تعداد </span><b>{rowCount}</b><span> رکورد یافت شد</span>
//                                     </div>
//                                     : <div style={{ padding: '8px 0', textAlign: 'center' }}><span>رکوردی یافت نشد.</span></div>}
//                             </>
//                             : <></>
//                         }
//                     </Col>
//                 </Row>

// {/* این بخش در صفحه مرورگر نمایش داده نمی‌شود و فقط برای چاپ است */}
//             <div className="only-print">
//                 <div ref={printRef}>
//                     <PrintableReservesReport 
//                         reserves={reservesData}
//                         currentPage={currentPage}
//                         pageSize={pageSize}
//                         searchCriteria={searchFilters}
//                     />
//                 </div>
//             </div>


//                     <ReservesGrid
//                 reserves={reserves}
//                 // rowNumber={((currentPageState - 1) * pageSize) + 1} // ردیف بندی را در ReservesGrid مدیریت کنید
//                 onItemClick={(id) => { setSelectedId(id); setView('AReserve') }}
//                 // پراپ های جدید برای سرور ساید سورتینگ
//                 currentSortColumn={sortColumn}
//                 currentSortOrder={sortOrder}
//                 currentPage={currentPage} // این باید یک عدد باشد
//     pageSize={pageSize}  
//                 onTableChange={handleTableChange} // تابع جدید برای دریافت تغییرات مرتب سازی
//             />

//             {totalItems > 0 ?
//                 <ConfigProvider direction="rtl" locale={faIR}>
//                     <Pagination
//                         current={currentPage}
//                         pageSize={pageSize}
//                         showSizeChanger={true}
//                         pageSizeOptions={['15', '30', '50', '75']}
//                         showQuickJumper={false}
//                         align="center"
//                         onChange={handlePageChange}
//                         onShowSizeChange={handlePageChange}
//                         total={totalItems} // استفاده از totalItems
//                     />
//                 </ConfigProvider>
//                         : <></>}
//                 </> : <></>}

//             {view === "AReserve" ?
//                 <AReserveComponent
//                     setLoading={setLoading}
//                     showMessage={showMessage}
//                     reserveId={selectedId}
//                     onBackClick={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
//                     onFoodClick={(id) => { setSelectedId(id); setView('AFoodReserve'); }}
//                 /> : <></>}

//             {view === "AFoodReserve" ?
//                 <AReserveFoodsAndParking
//                     setLoading={setLoading}
//                     showMessage={showMessage}
//                     reserveId={selectedId}
//                     onBackClick={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
//                     onPayCompleted={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
//                 /> : <></>}

//         </>
//     );
// };